module.exports = __webpack_public_path__ + "media/images/partners/ocenka2025-d184f60bf4cf604a0221154a6a8265c9.svg";